import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./contexts/AuthProvider";

import "./i18n";
import { initGA } from "./analytics/ga";
initGA();
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root not found");

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>
);
